<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'Download Client Files'"></Teranet-PageTitle>
    <form [formGroup]="downloadInputFileForm" #downloadform="ngForm" novalidate>
      <div fxFlex="100" fxLayout="row wrap" class="mat-elevation-z4">
        <div fxFlex="100">
          <Teranet-ClientTitle
            [ClientTitle]="'Lookup Client Files'"
            [IconName]="'file-download'"
          ></Teranet-ClientTitle>
        </div>
        <div fxLayout.xs="column" fxLayout="row wrap">
          <div class="form-group-flex-column">
            <mat-label class="required-field-after">Client</mat-label>
            <mat-form-field appearance="outline">
              <mat-select
                required
                formControlName="clientId"
                placeholder="--Please Select--"
                (selectionChange)="onClientChange()"
              >
                <mat-option *ngFor="let si of clientInfos" [value]="si.id">
                  {{ si.corporationName }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="downloadInputFileForm.get('clientId').hasError('required')"
                >Please select Client</mat-error
              >
            </mat-form-field>
          </div>
          <div class="form-group-flex-column">
            <mat-label class="required-field-after">File Type</mat-label>
            <mat-form-field appearance="outline">
              <mat-select
                required
                placeholder="--Please Select--"
                formControlName="fileTypeId"
                (selectionChange)="onFileTypeChange()"
              >
                <mat-option *ngFor="let ft of fileTypes" [value]="ft.id">
                  {{ ft.description }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="downloadInputFileForm.get('fileTypeId').hasError('required')"
                >Please select file type</mat-error
              >
            </mat-form-field>
          </div>
          <div class="form-group-flex-column">
            <mat-label class="required-field-after">From Date</mat-label>
            <mat-form-field appearance="outline">
              <input
                matInput
                [matDatepicker]="picker1"
                data-lpignore="true"
                name="fromDate"
                formControlName="fromDate"
                required
                (dateChange)="onFromDateChange()"
              />
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <mat-error *ngIf="downloadInputFileForm.get('fromDate').hasError('required')">
                Please provide valid date
              </mat-error>
              <mat-error
                *ngIf="
                  downloadInputFileForm.get('fromDate').errors?.min &&
                  downloadInputFileForm.get('toDate').errors?.min
                "
              >
                To Date must be bigger than or equal to From Date
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-group-flex-column">
            <mat-label class="required-field-after">To Date</mat-label>
            <mat-form-field appearance="outline">
              <input
                matInput
                [matDatepicker]="picker2"
                data-lpignore="true"
                name="toDate"
                formControlName="toDate"
                required
                (dateChange)="onToDateChange()"
              />
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
              <mat-error *ngIf="downloadInputFileForm.get('toDate').hasError('required')">
                Please provide valid date
              </mat-error>
              <mat-error
                *ngIf="
                  downloadInputFileForm.get('fromDate').errors?.min &&
                  downloadInputFileForm.get('toDate').errors?.min
                "
              >
                To Date must be bigger than or equal to From Date
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="end" fxFlex="100">
          <button mat-raised-button class="plain-button-lg" (click)="reset()" type="reset">
            Clear Criteria
          </button>
          <button mat-raised-button class="theme-button-lg" (click)="lookup()" type="submit">
            Lookup
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="teranet-padding" fxFlex="100" [hidden]="isHideGrid">
    <ngx-spinner
      [fullScreen]="false"
      type="ball-clip-rotate-multiple"
      bdColor="rgba(51,51,51,0.8)"
      size="medium"
      color="#fff"
    ></ngx-spinner>
    <Teranet-CustomizedGrid
      [data]="fileList"
      [gridName]="'file-list'"
      [gridSettings]="gridSettings"
      [initialGridSettings]="GridDefaultSettings()"
      [isFinishLoading]="true"
      [pageName]="'file-list'"
    ></Teranet-CustomizedGrid>
  </div>
</div>
